module.exports = __webpack_public_path__ + "img/icon-2.ebce17ea.svg";